<template>
  <router-view />
</template>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  font-family: 'Segoe UI', 'Hiragino Sans', sans-serif;
  background: #f0f2f5;
  color: #1f2328;
}
</style>
